import { render, staticRenderFns } from "./user.vue?vue&type=template&id=40968557&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=40968557&prod&lang=scss&scoped=true&"
import style1 from "./user.vue?vue&type=style&index=1&id=40968557&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40968557",
  null
  
)

export default component.exports